import { render, staticRenderFns } from "./ModalPrazoEntrega.vue?vue&type=template&id=3be1ac9f&scoped=true"
import script from "./ModalPrazoEntrega.vue?vue&type=script&lang=js"
export * from "./ModalPrazoEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be1ac9f",
  null
  
)

export default component.exports